import { getCurrencies } from "../../api/SelectApi";
import InputSelect from "../InputSelect";
import { tr } from "../../i18n";

const SelectCurrency = (props) => {
  const data = {
    name: "currency",
    placeholder: tr("shared:select_currency"),
    defaultValue: props.defaultValue,
    rules: props.rules,
    className: props.className,
  };

  async function handleData(search = "") {
    const result = await getCurrencies(search);
    return result.data.map((d) => ({
      label: d.text,
      value: d.id,
    }));
  }

  return (
    <InputSelect props={props} data={data} handleOnLoadData={handleData} />
  );
};

export default SelectCurrency;
